import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ComputedRef, PropType, ref, watch } from 'vue';

import { useGetTypeQuery, useGetTypesQuery } from '@/entities/type/hooks';
import { useGetDeviceQuery, useGetDevicesQuery } from '@/entities/device/hooks';

import { ChildrenForModel, Type } from '@/entities/type/types';
import { Device } from '@/entities/device/types';

import { NkModal, NkGrid, NkCol, NkButton } from '@/core/components';
import NkDeviceCreateForm from '@/entities/device/components/form/DeviceCreateForm.vue';
import NkDeviceCard from '@/entities/device/components/device-card/NkDeviceCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceByTypeCreateForm',
  props: {
  parentId: {
    type: Number as PropType<Device['id']>,
    default: null,
  },
  typeId: {
    type: Number as PropType<Type['id']>,
    required: true,
  },
  visible: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const isVisible = ref(false);
const typeQueryData = computed(() => ({ id: props.typeId }));
const hasTypeQueryData = computed(() => !!typeQueryData.value.id);
const parentQueryData = computed(() => ({ id: props.parentId }));
const hasParentQueryData = computed(() => !!parentQueryData.value.id);

const { data: type } = useGetTypeQuery(typeQueryData, { enabled: hasTypeQueryData });
const { data: parent } = useGetDeviceQuery(parentQueryData, { enabled: hasParentQueryData });
const { data: types } = useGetTypesQuery();
const { data: devices } = useGetDevicesQuery();

const chosenTypeId = ref();

const existingTypes = computed(() => devices.value?.filter(device => parent.value?.subDevices.includes(device.id)).map(device => device.type) || []);

const childrenForModel: ComputedRef<ChildrenForModel[]> = computed(() => type.value?.childrenForModel?.map(o => ({
  type: (types.value?.find(t => t.id === o.type) as Type),
  repetition: o.repetition,
})) || []);

const allowedChildrenForModel = computed(() => childrenForModel.value?.filter(tc => {
  const repetitions = existingTypes.value?.reduce((acc, current) => acc + (current === (tc.type as Type).id ? 1 : 0), 0);

  return repetitions < tc.repetition;
}));

watch(() => isVisible.value, (visible: boolean) => {
  if (visible && allowedChildrenForModel.value.length === 1) {
    chosenTypeId.value = allowedChildrenForModel.value[0].type.id;
  } else {
    chosenTypeId.value = null;
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(allowedChildrenForModel).length)
    ? (_openBlock(), _createBlock(_unref(NkModal), {
        key: 0,
        modelValue: isVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isVisible).value = $event)),
        class: "max-w-screen-md"
      }, {
        reference: _withCtx(() => [
          _createElementVNode("span", {
            class: "inline",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {isVisible.value = true;}, ["prevent","stop"]))
          }, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        default: _withCtx(() => [
          (!chosenTypeId.value)
            ? (_openBlock(), _createBlock(_unref(NkGrid), { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allowedChildrenForModel), (children, i) => {
                    return (_openBlock(), _createBlock(_unref(NkCol), {
                      key: children.type.id,
                      span: _unref(allowedChildrenForModel).length >= 2 ? 6 : 12,
                      align: _unref(allowedChildrenForModel).length <= 1 ? 'center' : (i % 2 === 0 ? 'right' : 'left')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(NkDeviceCard, {
                          type: children.type.id,
                          onClick: ($event: any) => (chosenTypeId.value = children.type.id)
                        }, null, 8, ["type", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["span", "align"]))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(NkDeviceCreateForm, {
                key: 1,
                parent: props.parentId,
                "type-id": chosenTypeId.value,
                onSubmitted: _cache[1] || (_cache[1] = ($event: any) => (isVisible.value = false))
              }, null, 8, ["parent", "type-id"]))
        ]),
        _: 3
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})